import React, { useCallback } from 'react'
import { styled } from '@mui/material/styles'
import {
  Card,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  SxProps,
} from '@mui/material'
import { boxShadow, error, primary, defaultText } from '@/constant'
import { NotificationLevel } from '@/types'
import notifications_empty from '@/asset/img/notifications_empty.webp'
import { ImageIcon } from '@/icon'
import noti_app_highlight from '@/asset/img/noti_app_highlight.webp'
import noti_sys_default from '@/asset/img/noti_sys_default.webp'
import noti_app_default from '@/asset/img/noti_app_default.webp'
import noti_sys_highlight from '@/asset/img/noti_sys_highlight.webp'
import noti_org from '@/asset/img/noti_org.webp'
import noti_app from '@/asset/img/noti_app.webp'

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const Filter = ({
  label,
  value,
  options,
  onChange,
  sx,
}: {
  label: string;
  value: string | number;
  options: { label: string; value: string | number }[];
  onChange: (value: string | number) => void;
  sx?: SxProps;
}) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      const value = event.target.value
      onChange(value)
    },
    [onChange]
  )

  return (
    <FormControl fullWidth sx={{ maxWidth: '160px', ...sx }} size='small'>
      <InputLabel sx={{ fontSize: '14px', lineHeight: '14px' }}>
        {label}
      </InputLabel>
      <Select
        variant='outlined'
        // @ts-ignore
        value={value}
        label={label}
        onChange={handleChange}
        inputProps={{
          style: {
            border: '1px solid #D9D9D9',
            borderRadius: '4px',
          },
        }}
        sx={{
          '& > div': {
            padding: '4px 16px',
            fontSize: '14px',
          },
        }}
      >
        {options?.map((option, index) => (
          <MenuItem key={`select-option-${index}`} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const levelColor: { [key in NotificationLevel]: string } = {
  high: error,
  medium: '#F7B500FF',
  low: '#0091FFFF',
}

const levelBackgournd: { [key in NotificationLevel]: string } = {
  high: 'rgba(255,102,93,0.1)',
  medium: 'rgba(247,181,0,0.1)',
  low: 'rgba(0,145,255,0.1)',
}

export const levelLetter: { [key in NotificationLevel]: string } = {
  high: '高',
  medium: '中',
  low: '低',
}

export const LevelTag = styled('div', {
  shouldForwardProp: (prop) => prop !== 'level',
})<{ level: NotificationLevel }>(({ level }) => ({
  display: 'inline-block',
  backgroundColor: levelBackgournd[level],
  color: levelColor[level],
  lineHeight: '24px',
  fontSize: '12px',
  width: '46px',
  textAlign: 'center',
  borderRadius: '4px',
}))

export const CatTag = styled('div')(() => ({
  display: 'inline-block',
  backgroundColor: '#52C41A1C',
  color: primary,
  lineHeight: '24px',
  fontSize: '12px',
  textAlign: 'center',
  padding: '0 8px',
  borderRadius: '4px',
}))

export const ReadTag = styled('div')(() => ({
  display: 'inline-block',
  backgroundColor: '#F7F7F7',
  color: defaultText,
  lineHeight: '24px',
  fontSize: '14px',
  width: '48px',
  textAlign: 'center',
  borderRadius: '4px',
}))

export const CenterPage = styled('div')(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}))

export const NotificationEmptyIcon = () => (
  <ImageIcon
    src={notifications_empty}
    sx={{
      width: '100px',
      height: '100px',
    }}
  />
)

export const AppIcon = ({ active }: { active: boolean }) => {
  return (
    <ImageIcon
      src={active ? noti_app_highlight : noti_app_default}
      sx={{ width: '18px' }}
    />
  )
}

export const SystemIcon = ({ active }: { active: boolean }) => {
  return (
    <ImageIcon
      src={active ? noti_sys_highlight : noti_sys_default}
      sx={{ width: '18px' }}
    />
  )
}

export const OrgTagIcon = () => (
  <ImageIcon src={noti_org} sx={{ width: '18px', minWidth: '18px' }} />
)

export const AppTagIcon = () => (
  <ImageIcon src={noti_app} sx={{ width: '18px' }} />
)
